import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { PhActions } from '../phActions';

export function* handlePhNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    PhActions.HANDLE_PH_NAVIGATION_TO_ANGEBOT,
    safeSaga(handlePhNavigationToAngebot, App.PH),
  );
}

export function* handlePhNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.PH,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.PH &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new PhActions().quoteDBRequested());
  yield put(new PhActions().preiseRequested());
  yield put(new PhActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.PH,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
